import { createSlice } from "@reduxjs/toolkit";

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    isNetworkError: false,
    // WebSocket 重連訊號：每次 pusher 真的 connect 成功就 +1，
    // 各 feature 可訂閱此值補拉斷線期間漏掉的資料（參考 CLAUDE.md「WebSocket 重連與資料補拉」）
    reconnectTick: 0,
    // 帳號停權通知：'account' 時 App 顯示帳號停權通知 modal，關閉後清回 null
    suspensionNotice: null,
  },
  reducers: {
    setNetworkError(state, action) {
      state.isNetworkError = action.payload;
    },
    bumpReconnectTick(state) {
      state.reconnectTick += 1;
    },
    setSuspensionNotice(state, action) {
      state.suspensionNotice = action.payload;
    },
  }
});

export const { setNetworkError, bumpReconnectTick, setSuspensionNotice } = appSlice.actions;
export default appSlice.reducer;
